// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5544":"b3f16950e847258e","9910":"cf03d729ee12b849"}[chunkId] + ".css";
};